// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer","footer-copyright":"footer-copyright"};